import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=204083b8"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports